module.exports = __webpack_public_path__ + "img/contact_img_01_mobile.4b7107e0.jpg";